'use client';

import { useCookieConsent } from '@packages/shared/src/hooks/useCookieConsent/useCookieConsent';
import Script from 'next/script';
import type { FunctionComponent } from 'react';

export type ClarityProps = {
  /** The Clarity project ID */
  clarityId?: string;
};

/**
 * Clarity component that injects the Clarity tracking script into the page if the user has given consent for the C0003 cookie and a valid clarityId is provided.
 * @param {ClarityProps} props - The props for the Clarity component.
 * @returns {JSX.Element | null} The Clarity tracking script or null if the user has not given consent or if no valid clarityId is provided.
 */
export const Clarity: FunctionComponent<ClarityProps> = ({ clarityId }) => {
  const isConsentAllowed = useCookieConsent('C0003');
  return isConsentAllowed && clarityId && clarityId !== '' ? (
    <Script
      id="clarity-component"
      dangerouslySetInnerHTML={{
        __html: `(function(c,l,a,r,i,t,y){c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);})(window, document, "clarity", "script", "${clarityId}");`,
      }}
    />
  ) : null;
};
